import seo from '@/core/data/landingSeo.json'

const L = seo.locales.zh

export default {
  hero: L.hero,
  startFree: "免费开始",
  features: {
    altTemplate: "用于展示{title}功能的视觉示例",
    items: {
      learnStyle: {
        title: "以参考图学习风格",
        description: "选择喜欢的参考图，拆解它背后的影调、色彩与氛围。",
      },
      seeGaps: {
        title: "看见并读懂差异",
        description: "用可视化图表和差距卡片理解影调、色彩与饱和度。",
      },
      aiAnalysis: {
        title: "先理解，再调整",
        description: "AI 结合画面证据，解释风格成因与下一步方向。",
      },
      applyStyle: {
        title: "把风格用到自己的照片",
        description: "结合照片条件，判断哪些风格要素适合迁移。",
      },
    },
  },
  advantages: {
    title: "从理解风格到独立创作",
    items: {
      styleLearning: {
        title: "学习风格，而非死板模仿",
        description:
          "参考图并不是机械套用的模板，而是学习风格的入口。PhotoScope 帮你看懂它在影调、色彩与氛围上的视觉规律，掌握审美的核心成因。",
      },
      gapVisualization: {
        title: "看见差异，也读懂差异",
        description:
          "通过亮度分布、通道关系及色彩倾向等直观图表，配合结构化的关键差距卡片，让复杂的图像差距一目了然，告别无从下手的迷茫。",
      },
      aiInsights: {
        title: "理解成因，掌握调整方向",
        description:
          "AI 不仅告诉你差异在哪里，更深入解释这些差异如何影响画面感，并结合摄影美学提供针对性的后期调整优先级，引导你完成练习。",
      },
      styleAdaptation: {
        title: "学会应用，保留独特个性",
        description:
          "强调知识的迁移。根据你照片的原始拍摄条件，判断参考风格如何合理融入，不盲目套用滤镜，在提升质感的同时保留作品本身的个性。",
      },
    },
  },
  steps: {
    title: "循序渐进：从理解风格到完成创作",
    items: {
      upload: {
        title: "上传原图并选择参考风格",
        description: "上传你自己的照片，并选择一张想要解析与学习的参考风格图。",
      },
      analyze: {
        title: "读懂可视化差距",
        description:
          "通过并排对比视图、直观的交互图表与结构化差距卡片，快速理清关键差异与调整优先级。",
      },
      edit: {
        title: "阅读指南并尝试后期",
        description:
          "阅读包含 AI 解析的详细后期编辑指南，并在修图软件中将这些具体的调整思路应用到你自己的照片上。",
      },
      review: {
        title: "上传编辑版，回顾复盘",
        description:
          "上传你编辑后的照片，查看专属的复盘反馈（即将上线），并生成、分享 Before / After 对照图。",
      },
    },
  },
  useCases: {
    title: "为不同阶段的摄影学习者而设计",
    items: {
      beginners: {
        title: "入门者",
        description: {
          0: "选择喜欢的参考图，直观看懂优秀照片的影调与色彩规律。",
          1: "用直观图表和差距卡片，轻松理解自己的照片为什么不同。",
          2: "在 AI 解析中学习基础摄影语言，并获得清晰的调整方向。",
        },
      },
      enthusiasts: {
        title: "进阶爱好者",
        description: {
          0: "深入拆解你喜欢的风格作品，理解其色彩、层次与氛围来源。",
          1: "快速定位当前照片与参考图之间的关键差距和调整优先级。",
          2: "将视觉直觉转化为有依据的后期判断，显著提高创作效率。",
        },
      },
      aesthetic: {
        title: "美学探索者",
        description: {
          0: "借助参考图，研究不同视觉风格背后的审美秩序与情绪表达。",
          1: "剖析色彩倾向与明暗关系，理解画面氛围是如何被构建的。",
          2: "将感性的美学体验，转化为可描述、可比对的系统化分析。",
        },
      },
      practical: {
        title: "实用摄影者",
        description: {
          0: "用参考图确立清晰的视觉基准，避免后期调色时反复试错。",
          1: "根据精准的差距卡片，优先调整亮度层级与高光色调等核心项。",
          2: "回传编辑后照片并生成 Before/After 对照，复盘并沉淀成果。",
        },
      },
    },
  },
  testimonials: {
    title: "用户评价",
    items: {
      sarah: {
        name: "Sarah Chen",
        content:
          "我以前只知道参考图“更好看”，但不知道为什么。PhotoScope 把影调和色彩差异拆出来后，我终于知道该先看哪里。",
      },
      michael: {
        name: "Michael Rodriguez",
        content:
          "它没有让我机械复制参考图，而是告诉我哪些差距真正影响风格感。我的后期调整变得更有顺序。",
      },
      emma: {
        name: "Emma Thompson",
        content:
          "我喜欢它把氛围感解释成可观察的图表和文字。每次对比之后，我都更清楚自己想表达什么。",
      },
    },
  },
  faq: L.faq,
  footer: {
    copyright: "© 2026 PhotoScope。保留所有权利。",
    product: {
      title: "产品",
      photoscope: "PhotoScope",
      beforeAfter: "Before & After"
    },
    resources: {
      title: "资源",
      pricing: "价格",
      blog: "博客"
    },
    company: {
      title: "公司",
      contact: "联系我们",
      terms: "使用条款",
      privacy: "隐私政策"
    }
  },
  pricing: {
    billing: {
      monthly: "按月",
      yearly: "按年",
    },
    badge: {
      yearlyDiscount: "最高省{percent}%",
    },
    card: {
      recommended: "推荐",
      currentPlan: "当前套餐",
      perMonth: "/月",
      save: "节省{percentage}%",
      discountPercent: "{percentage}%",
      billedAnnually: "按年支付，{price}/年",
    },
    button: {
      subscribe: "订阅",
      buyOnce: "一次性购买",
      getStarted: "立即开始",
    },
    tiers: {
      free: "免费",
      standard: "标准",
      pro: "专业",
    },
    section: {
      title: "选择你的方案",
      subtitle: "免费开始使用，需要更多功能时随时升级。",
    },
    cta: "立即开始",
  },
  blog: {
    section: {
      title: "最新文章",
      subtitle: "探索掌握照片分析的洞见与实用技巧",
      viewAll: "查看全部文章",
    },
    categories: {
      Guides: "指南",
      Concepts: "概念",
    },
    card: {
      publishedOn: "发布于",
    },
    cta: {
      title: "用 PhotoScope 分析你自己的照片",
      button: "上传你的照片",
      subtitle: "与任意参考图对比，把视觉差异转化为清晰、可执行的分析结论。",
    },
  },
};
